var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-header',{staticClass:"voting__header",attrs:{"with-navigation":true}},[(_vm.isVotingButtonVisible)?_c('header-voting-button',{attrs:{"slot":"right-section"},slot:"right-section"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }